// breakpoint em que o swiper será destruído
import Swiper from "swiper";

const breakpoint = window.matchMedia( '(min-width:992px)' );

let mySwiper;
let topicSwiper;

const breakpointChecker = function() {

	if ( breakpoint.matches === true ) {
		if ( mySwiper !== undefined ) mySwiper.destroy( true, true );
		topicDesktopSwiper();
		return;
	} else if ( breakpoint.matches === false ) {
		topicMobileSwiper();
		// return enableSwiper(); // Por problemas de efeito colateral, trecho movido para load-more.php
	}
};

const enableSwiper = function() {
	mySwiper = new Swiper('.swiper-container', {
		slidesPerView: 1,
		spaceBetween: 30,
		loop: true,
		pagination: {
			el: '.swiper-pagination-feature',
			clickable: true,
		},
		navigation: {
			nextEl: '.destaques-button-next',
			prevEl: '.destaques-button-prev',
		},
	});
};

// Carousel Nossos tópicos

const topicDesktopSwiper = function() {
	topicSwiper = new Swiper('.swiper-topic-container', {
		slidesPerView: 3,
		spaceBetween: 15,
		loop: true,
		slidesPerGroup: 1,
		pagination: {
			clickable: false,
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	});
};

const topicMobileSwiper = function() {
	topicSwiper = new Swiper('.swiper-topic-container', {
		slidesPerView: 2,
		spaceBetween: 15,
		slidesPerGroup: 1,
		pagination: {
			el: '.swiper-pagination-topic',
			clickable: false,
		},
		navigation: {
			nextEl: '.topic-button-next',
			prevEl: '.topic-button-prev',
		},
	});
};

// Verificar alterações no tamanho das janelas
breakpoint.addListener(breakpointChecker);
breakpointChecker();


const swiper_post_dinamically = function(post_id) {
	postSwiper = new Swiper('.swiper-post-container-'+post_id, {
		slidesPerView: 'auto',
		spaceBetween: 0,
		slidesPerGroup: 1,
		pagination: {
			clickable: false,
		},
		navigation: {
			nextEl: '.swiper-next-post-'+post_id,
			prevEl: '.swiper-prev-post-'+post_id,
		},
	});
};
